import React from "react";
import "./css/Gallery.css";
import Imageviewer from "./Imageviewer";

const Gallery = () => {
  return (
    <>
      <div className="container-fluid">
        {/* <div className="first">
          <div className="one two">
            <img src="./images/g1.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g2.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g3.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g4.jpeg" alt="" />
          </div>
        </div>
        <div className="first">
          <div className="one two">
            <img src="./images/g-5.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g-6.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g7.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g8.jpeg" alt="" />
          </div>
        </div>
        <div className="first">
          <div className="one two">
            <img src="./images/g9.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g10.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g11.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g12.jpeg" alt="" />
          </div>
        </div>
        <div className="first">
          <div className="one two">
            <img src="./images/g13.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g14.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g15.jpeg" alt="" />
          </div>
          <div className="one two">
            <img src="./images/g16.jpeg" alt="" />
          </div>
        </div> */}
        <Imageviewer/>
      </div>
    </>
  );
};

export default Gallery;
